module.exports = __webpack_public_path__ + "images/4c215c375c5c18fa6aa78fbaa36c55f9.png";